import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { HeaderConfig } from "./config";
import { getOfflineData } from "../../../utils/offline-services";
import { invokeApi, HTTP_METHODS, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import AppContext from "../../../utils/context";
import {
  TICKET_STAGES,
  USER_LIMITS,
  USER_ROLES,
} from "../../../utils/constants";
import TicketFilters from "../../../core/ticket-filters";
import CustomTable from "../../../core/custom-table";
import TicketCard from "./mobile-view-ticket";
import { checkForUserLimit, PAGE_LIMIT } from "../../../utils";
import CustomButtonComponent from "../../../core/custom-button";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
const PastTickets = ({ isShowPendingTickets = false }) => {
  const storedFilters = JSON.parse(
    sessionStorage.getItem("pastTicketsFilters")
  );
  const ticketsMainFilters = JSON.parse(
    sessionStorage.getItem("pastTicketsMainFilters")
  );
  const ticketsFiltersObject = JSON.parse(
    sessionStorage.getItem("pastTicketsFiltersObject")
  );
  const { userDetails = {} } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [viewTicket, setViewTicket] = useState(null);
  const [mainFilters, setMainFilters] = useState(ticketsMainFilters || {});
  const [isLoading, setIsLoading] = useState(false);
  const [filterObjects, setFiltersObject] = useState(
    ticketsFiltersObject || {}
  );
  const [pastTickets, setPastTickets] = useState({
    results: [],
  });

  const [filters, setFilters] = useState(
    storedFilters || {
      page: 1,
      limit: PAGE_LIMIT,
      sortBy: "-createdAt",
    }
  );
  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else if (userDetails && userDetails.id) {
      loadData({ ...filters, ...mainFilters });
    }
  }, [userDetails]);

  const loadData = (filters) => {
    const payload = { ...filters };
    if (isShowPendingTickets && !payload.approveStatus) {
      payload["stage"] = TICKET_STAGES.APPROVER_ASSIGNED;
    }

    let url = REST_URLS.LIST_OEM_TICKETS;

    if (userDetails.role === USER_ROLES.ADMIN) {
      url = REST_URLS.TICKETS;
    }
    setIsLoading(true);
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${url}`, null, payload)
      .then((response) => {
        if (response.results) {
          setPastTickets(response);
        }
        setIsLoading(false);
      })
      .catch((error) => console.error(error));
  };

  const getComplaintDetails = (data) => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.COMPLAINT}/${data.id}`,
      null
    )
      .then((response) => {
        if (response) {
          setViewTicket({
            ticketId: data.id,
            ...response,
          });
        }
      })
      .catch((err) => console.error(err));
  };

  const onRowClick = (data) => {
    if (userDetails.role === USER_ROLES.ADMIN) {
      navigate(`/admin/details/${data.id}`);
    } else {
      getComplaintDetails(data);
    }
  };
  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.DOWNLOAD_TICKETS}`,
      null,
      { ...mainFilters },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Tickets.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (filters) {
      sessionStorage.setItem("pastTicketsFilters", JSON.stringify(filters));
    }
    if (mainFilters) {
      sessionStorage.setItem(
        "pastTicketsMainFilters",
        JSON.stringify(mainFilters)
      );
    }
    if (filterObjects) {
      sessionStorage.setItem(
        "pastTicketsFiltersObject",
        JSON.stringify(filterObjects)
      );
    }
  }, [filters, mainFilters, filterObjects]); // Runs whenever filters change
  useEffect(() => {
    if (
      pastTickets?.totalPages !== 0 &&
      pastTickets?.totalPages < pastTickets?.page
    ) {
      setFilters({ ...filters, page: 1 });
      loadData({
        ...filters,
        ...mainFilters,
        page: 1,
      });
    }
  }, [pastTickets]);

  return (
    <>
      <div className="page-body page-load">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <p className="tab-name">Complaint handling</p>
            <p className="section-name">Service Tickets</p>
          </div>
          {(checkForUserLimit(USER_LIMITS.ADMIN, userDetails?.limits) ||
            checkForUserLimit(
              USER_LIMITS.QUALITY_ADMIN,
              userDetails?.limits
            )) && (
            <CustomButtonComponent
              variant="contained"
              color="success"
              startIcon={
                <Icon
                  icon="solar:download-bold-duotone"
                  width="1.2rem"
                  height="1.2rem"
                  style={{ color: "white" }}
                />
              }
              onClick={downloadReports}
            >
              Download
            </CustomButtonComponent>
          )}
        </Box>
        <div className="si-hide-mobile">
          <CustomTable
            header={HeaderConfig}
            data={pastTickets.results || []}
            pageCount={pastTickets.totalPages}
            onClick={onRowClick}
            filters={filters}
            onChange={(page) => {
              const updatedFilters = { ...filters, page };

              setFilters(updatedFilters);
              sessionStorage.setItem(
                "pastTicketsFilters",
                JSON.stringify(updatedFilters)
              );
              loadData({
                ...updatedFilters,
                ...mainFilters,
              });
            }}
            filterCom={
              <TicketFilters
                loadData={loadData}
                setMainFilters={setMainFilters}
                filter={filters}
                setFiltersObject={setFiltersObject}
              />
            }
            isLoading={isLoading}
          />
        </div>
        <div className="si-hide-web ">
          <div>
            <TicketFilters
              loadData={loadData}
              setMainFilters={setMainFilters}
              filter={filters}
              setFiltersObject={setFiltersObject}
            />
          </div>
          {pastTickets.results.map((ticket) => {
            return (
              <div key={ticket.id}>
                <div>
                  <TicketCard
                    onClick={() => onRowClick(ticket)}
                    ticketId={ticket.id}
                    status={ticket.status}
                    createdBy={ticket.createdBy?.name}
                    assignedTo={ticket.serviceEngineer?.name}
                    createdOn={ticket.createdAt}
                  ></TicketCard>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default PastTickets;
